const ThemeDefinition = {
  typography: {
    root: 'typography',
    label: 'typography--label',
    h1: 'typography--h1',
    text: 'text',
    title: 'title',
    description: 'description',
  },
  layout: {
    arButton: 'basic-3d-layout__ar-button',
    logo: 'basic-3d-layout__logo',
    controls: 'basic-3d-layout__controls',
    header: 'basic-3d-layout__header',
  },
  integrationButton: 'integration__button',
  arControl: {
    button: 'ar-control__button',
    dialog: 'ar-control__dialog',
  },
  canvasLogicBranding: 'canvas-logic-branding',
  listSelector: {
    root: 'list-selector',
    options: 'list-selector__options',
  },

  listSelectorItem: {
    root: 'list-selector-item',
    selected: 'list-selector-item--selected',
    /**
     * Root of the visual container of the item
     */
    label: 'list-selector-item__label',
    title: 'list-selector-item__title',
    imageWrapper: 'list-selector-item__image-wrapper',
    image: 'list-selector-item__image',
    description: 'list-selector-item__description',
  },
  pillsSelector: {
    root: 'pills-selector',
    options: 'pills-selector__options',
  },
  pillsSelectorItem: {
    root: 'pills-selector-item',
    selected: 'pills-selector-item--selected',
  },
  htmlBlock: {
    root: 'html-block',
  },
  card: {
    root: 'card',
    selected: 'card--selected',
    imageWrapper: 'card__image-wrapper',
    text: 'card__text',
    image: 'card__image',
    button: 'card__button',
  },
  attributeDetails: {
    root: 'attribute-details',
  },
  componentGrid: {
    root: 'component-grid',
    options: 'component-grid__options',
  },
  componentList: {
    root: 'component-list',
    options: 'component-list__options',
  },
  componentGridItem: {
    root: 'component-grid-item',
    selected: 'component-grid-item--selected',
  },
  qrCodeDialog: {
    root: 'qr-code-dialog',
    text: 'qr-code-dialog__text',
  },
  uiBuilder: {
    control: 'ui-builder__control',
  },
  selectorLabel: {
    root: 'selector-label',
    icon: 'selector-label__icon',
    label: 'selector-label__label',
    description: 'selector-label__description',
  },
  toggleSelector: {
    root: 'toggle-selector',
    button: 'toggle-selector__button',
    icon: 'toggle-selector__icon',
    label: 'toggle-selector__label',
    description: 'toggle-selector__description',
  },
  toggleButton: {
    root: 'toggle-button',
    selected: 'toggle-button--selected',
    disabled: 'toggle-button--disabled',
  },
  logo: {
    root: 'logo',
  },
  dialog: {
    root: 'dialog',
    content: 'dialog__content',
    controls: 'dialog__controls',
  },
  notificationContainer: {
    root: 'notification-container',
    backdrop: 'notification-container__backdrop',
  },
  notification: {
    root: 'notification',
    error: 'notification--error',
  },
} as const;

export default ThemeDefinition;
